import React, { createContext, useContext } from 'react';
import useDrawer from '../hooks/useDrawer';

/**
 * Context for sharing drawer state across components
 */
const DrawerContext = createContext();

/**
 * Provider component that wraps the app and provides drawer state
 */
export const DrawerProvider = ({ children }) => {
  const drawerState = useDrawer();
  
  return (
    <DrawerContext.Provider value={drawerState}>
      {children}
    </DrawerContext.Provider>
  );
};

/**
 * Hook to consume drawer context
 * This ensures all components share the same drawer state instance
 */
export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawerContext must be used within a DrawerProvider');
  }
  return context;
};

export default DrawerContext;
